import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import Select from "react-select";
import "react-toastify/dist/ReactToastify.css";
import {
  CreateVehicleCapacityDetails,
  UpdateVehicleCapacityDetails,
  AllVehicleCapacityDetails,
  AllVehicleTypeDetails,
} from "../../Apis/vehicleApi";
import { AllCollectionTypeDetails } from "../../Apis/collectionTypeApi";
import TableComponent from "../../Common/TableComponent/tableComponent";
import { TableLoader } from "../../Common/ShimmerLoader";
import { useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";
import * as XLSX from "xlsx"; // Import XLSX library for Excel operations
import ExcelJS from "exceljs";

const VehicleCapacity = ({ t }) => {
  const navigate = useNavigate();
  const headers = [
    "vehicleCapacity",
    "vehicleCapacityCode",
    "vehicleType",
    "status",
    "actions",
  ];
  const [lgShow, setLgShow] = useState(false);
  const [vehicleTypeDetails, setVehicleTypeDetails] = useState([]);
  const [collectionTypeDetails, setCollectionTypeDetails] = useState([]);
  const [editVehicleTypeData, setEditVehicleTypeData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [collectionDetails, setCollectionDetails] = useState([]);
  const [sortedData, setSortedData] = useState([]); // New state to store sorted data
  const [excelData, setExcelData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [sortConfig, setSortConfig] = useState(null);
  const [filterOriginalVehicleCapacityData, setFilterOriginalVehicleCapacityData] = useState([]);
  const [formInput, setFormInput] = useState({
    vehicleCapacityName: "",
    isActive: true, // Set isActive to true by default
    vehicleCapacityCode: "",
    vehicleTypeId: ""
  });

  const [vehicleTypes, setVehicleTypes] = useState([]);

  // Fetch all vehicle types
  const fetchAllVehicleTypes = async () => {
    try {
      const response = await AllVehicleTypeDetails();
      setVehicleTypes(response);
    } catch (error) {
      console.error("Error fetching vehicle types:", error);
    }
  };


  useEffect(() => {
    fetchAllVehicleTypes();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Sanitize input based on field name
    switch (name) {
      case "vehicleCapacityName":
        // Remove leading spaces and replace multiple spaces with a single space
        const sanitizedValue = value
        // .replace(/[^a-zA-Z0-9\s]/g, "") // Allow only alphanumeric and spaces
        // .replace(/^\s+/, "") // Remove leading spaces
        // .replace(/\s{2,}/g, " "); // Replace multiple spaces with a single space

        setFormInput((prevData) => ({ ...prevData, [name]: sanitizedValue }));
        break;


      case "vehicleCapacityCode":
        // Allow only alphanumeric characters for the vehicle type code
        const sanitizedCode = value.replace(/[^a-zA-Z0-9-]/g, "").toUpperCase();
        setFormInput((prevData) => ({ ...prevData, [name]: sanitizedCode }));
        break;
      default:
        setFormInput((prevData) => ({ ...prevData, [name]: value }));
        break;
    }
  };

  const handleClose = () => {
    setFormInput({
      vehicleCapacityName: "",
      isActive: "",
      vehicleCapacityCode: "",
    });
    setLgShow(false); // Explicitly set lgShow to false
    setFormSubmitted(false);
  };

  const handleShow = () => {
    setLgShow(true);
    setFormInput({
      id: "",
      vehicleCapacityName: "",
      vehicleCapacityCode: "",
      isActive: true, // Set isActive to true by default
      vehicleTypeId: ""
    });
    setEditVehicleTypeData(null);
  };

  // Inside handleEditVehicleTypeData function, set collection type name in formInput state
  const handleEditVehicleTypeData = (selectedVehicleCapacity) => {
    setEditVehicleTypeData(selectedVehicleCapacity);
    setFormInput({
      vehicleTypeId: selectedVehicleCapacity.vehicleTypeId,
      vehicleCapacityCode: selectedVehicleCapacity.vehicleCapacityCode,
      vehicleCapacityName: selectedVehicleCapacity.vehicleCapacityName,
      isActive: selectedVehicleCapacity.isActive,
      vehicleCapacityId: selectedVehicleCapacity.vehicleCapacityId
    });
    setLgShow(true);
  };

  const vehcileTypeData = async () => {
    try {
      setIsLoading(true);
      const response = await AllVehicleCapacityDetails();
      setVehicleTypeDetails(response);

    } catch (error) {
      console.error("Error fetching shift data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const collectionTypeData = async () => {
    try {
      setIsLoading(true);
      const response = await AllCollectionTypeDetails();
      setCollectionTypeDetails(response);
    } catch (error) {
      console.error("Error fetching shift data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(
    () => {
      vehcileTypeData();
      collectionTypeData();
    },
    []
    // [lgShow]
  );

  const handleCreateVehicleTypeDetails = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);

    // Perform validation for both create & update
    if (
      !formInput.vehicleCapacityCode ||
      !formInput.vehicleCapacityName ||
      !formInput.vehicleTypeId
    ) {
      // toast.error("Please fill in all required fields.", {
      //   position: "top-right",
      //   autoClose: 5000,
      //   hideProgressBar: false,
      // });
      return; // Stop execution if validation fails
    }

    const isDuplicateCode = vehicleTypeDetails.some(
      (type) =>
        type.vehicleCapacityCode === formInput.vehicleCapacityCode &&
        type.vehicleCapacityId !== editVehicleTypeData?.vehicleCapacityId
    );

    if (isDuplicateCode) {
      toast.error(
        "Vehicle Capacity Code already exists. Please choose a different one.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        }
      );
      return; // Stop execution if duplicate code exists
    }

    try {
      setIsLoading(true);

      if (editVehicleTypeData) {
        // ✅ If validation fails, we never reach this part
        const updatedVehicleCapacityData = { ...formInput };
        const response = await UpdateVehicleCapacityDetails(
          updatedVehicleCapacityData
        );
        toast.success("Vehicle Capacity Updated Successfully");
      } else {
        const response = await CreateVehicleCapacityDetails(formInput);
        toast.success("Vehicle Capacity Added Successfully");
      }

      fetchAllVehicleTypeDetails();
      handleClose();
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;

        if (status === 400) {
          toast.error(data, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });

          // ✅ Prevent API calls if validation errors exist
          if (data.errors) {
            Object.keys(data.errors).forEach((field) => {
              data.errors[field].forEach((errorMessage) => {
                toast.error(errorMessage, {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                });
              });
            });
          }

          return; // Stop execution if 400 validation errors exist
        } else if (status === 409) {
          toast.error(data, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
          return; // Stop execution if duplicate error exists
        } else if (status === 404) {
          toast.error(data, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
          return; // Stop execution if not found
        }
      } else {
        toast.error("An error occurred. Please try again later.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        });
      }
    } finally {
      setIsLoading(false);
    }
  };


  // useEffect(() => {
  //   // Update formInput when editDriverData changes
  //   setFormInput(
  //     editVehicleTypeData || {
  //       vehicleCapacityName: "",
  //       isActive:true,
  //       vehicleCapacityCode: "",
  //     }
  //   );
  // }, [editVehicleTypeData]);

  const fetchAllVehicleTypeDetails = async () => {
    try {
      const [vehicleCapacityResponse, vehicleTypeResponse] = await Promise.all([
        AllVehicleCapacityDetails(),
        AllVehicleTypeDetails()
      ]);

      const vehicleTypeMap = new Map(vehicleTypeResponse.map(type => [type.vehicleTypeId, type.vehicleTypeName]));

      const vehicleCapacityData = vehicleCapacityResponse.map(station => {
        return {
          ...station,
          vehicleCapacity: station.vehicleCapacityName,
          status: station.isActive ? "Active" : "InActive",
          vehicleType: vehicleTypeMap.get(station.vehicleTypeId)
        };
      });

      // Sort the data based on the isActive field
      const sortedRouteData = vehicleCapacityData.sort((a, b) => {
        if (a.isActive === b.isActive) {
          return 0;
        }
        return a.isActive ? -1 : 1;
      });

      setCollectionDetails(sortedRouteData);
      setOriginalData(vehicleCapacityData);
      setFilterOriginalVehicleCapacityData(sortedRouteData);
    } catch (error) {
      console.error("Error fetching vehicle type details:", error);
    }
  };


  useEffect(() => {
    fetchAllVehicleTypeDetails();
  }, []);

  // const downloadAsExcel = () => {
  //   const dataWithSerialNumber = collectionDetails.map((item, index) => ({
  //     ...item,
  //     's.no': index + 1,
  //   }));

  //   const filteredData = dataWithSerialNumber.map(item => ({
  //     's.no': item['s.no'],
  //     vehicleCapacity: item.vehicleCapacity,
  //     vehicleCapacityCode: item.vehicleCapacityCode,
  //     vehicleType: item.vehicleTypeName,
  //     status: item.status,
  //   }));
  //   const ws = XLSX.utils.json_to_sheet(filteredData);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "vehicleCapacityData");
  //   const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //   const data = new Blob([excelBuffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  //   });
  //   const downloadLink = document.createElement("a");
  //   downloadLink.href = URL.createObjectURL(data);
  //   downloadLink.download = "vehicleCapacityData.xlsx";
  //   downloadLink.click();
  // };
  const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
  const generationTime = ` ${new Date().toLocaleString('en-GB', options).replace(/\//g, '/')}`;

  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const dataToUse = sortedData.length > 0 ? sortedData : originalData;
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1
      }-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Vehicle Capacity Details`;
    const downloadDateTime = `Vehicle Capacity Report Generated on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
    worksheet.mergeCells(1, 2, 1, 5); // Merge cells for downloadDateTime from column 2 to 4
    worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
    worksheet.getCell(1, 2).font = boldFont; // Set font style
    worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B1, C1, D1)
    for (let col = 2; col <= 5; col++) {
      worksheet.getCell(1, col).font = boldFont; // Set styles individually
      worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add "Zone Details" to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", "Vehicle Capacity Details", ""]); // Update array length to match new cell range
    worksheet.mergeCells(2, 2, 2, 5); // Merge cells for Zone Details from column 2 to 4
    worksheet.getCell(2, 2).value = "Vehicle Capacity Details"; // Ensure the value is set after merging
    worksheet.getCell(2, 2).font = boldFont; // Set font style
    worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B2, C2, D2)
    for (let col = 2; col <= 5; col++) {
      worksheet.getCell(2, col).font = boldFont; // Set styles individually
      worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    }


    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Vehicle Capacity",
      "Vehicle Capacity Code",
      "Vehicle Type",
      "Status"
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 5) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "003366" },
        };
      }
    });

    // Add data rows
    dataToUse.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.vehicleCapacityName,
        item.vehicleCapacityCode,
        item.vehicleType,
        item.status
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 5) {
          // Align the columns from 1 to 4 to the left
          cell.alignment = { horizontal: "left" };
        } else {
          // Align the rest of the columns to the center
          cell.alignment = { horizontal: "center" };
        }
      });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "VehicleCapacityDetails.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  let storedPermissions = localStorage.getItem('permissionId')
  const permissionValues1 = JSON.parse(localStorage.getItem('rolePermissions')) || {};
  let canWriteValue = null;

  // Convert storedPermissions to a number (if needed)
  storedPermissions = parseInt(storedPermissions, 10);

  // Find the matching roleToPermissionMapping object
  const matchingPermission = permissionValues1.find(mapping => mapping.permissionId === storedPermissions);

  if (matchingPermission) {
    canWriteValue = matchingPermission.canWrite;
    console.log(`canWrite value for permission ID ${storedPermissions}:`, canWriteValue);
  } else {
    console.log(`No match found for permission ID ${storedPermissions}`);
  }
  const handleSort = (sortConfig) => {
    // Assuming you have a method to sort data based on sortConfig
    const sorted = [...collectionDetails].sort((a, b) => {
      if (sortConfig.order === 'asc') {
        return a[sortConfig.column] > b[sortConfig.column] ? 1 : -1;
      } else {
        return a[sortConfig.column] < b[sortConfig.column] ? 1 : -1;
      }
    });

    setSortedData(sorted); // Update the sorted data
  };
  const handleSortAndExport = async () => {
    if (sortConfig) {
      handleSort(sortConfig); // Apply sorting
      await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for state update
    }
    const dataToExport = sortConfig ? sortedData : originalData; // Use sorted or original data
    downloadAsExcel(dataToExport); // Export the data
  };

  const searchVehicleCapacityHandler = (e) => {
    const term = e.target.value.toLowerCase();
    const data = filterOriginalVehicleCapacityData.filter(item => item?.vehicleCapacityName?.toLowerCase()?.includes(term) || item?.vehicleCapacityCode?.toLowerCase()?.includes(term));
    setCollectionDetails(data);
  }

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="top-header page-title">
              <span>{t("Vehicle Capacity Details")}</span>
            </div>
            <div className="page-header">
              <div className="row justify-content-between">
                <div className="col-md-3">
                  <div className="form-group">
                    <input
                      placeholder="Search Vehicle Capacity or Code"
                      type="text"
                      className="form-control bg-white"
                      onInput={searchVehicleCapacityHandler}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="flex_end_middle mb-3">
                    {/* {canWriteValue === true ? */}
                    <button className="button-container" onClick={handleShow}>
                      <i className="fa-solid fa-plus me-1 icon-container"></i>
                      {t("addVehicleCapacity")}
                    </button>
                    {/* : ""} */}
                    <button className="btn btn-excel"
                      onClick={handleSortAndExport}>
                      <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-body">
                <TableComponent isLoading={isLoading}
                  DataFetchURL={collectionDetails}
                  headers={headers}
                  filterFunction={(data) =>
                    data.filter(
                      (item) => item.status === 1 || item.status === 2
                    )
                  }
                  editData={handleEditVehicleTypeData} // Pass the callback function
                  editDataDetails={editVehicleTypeData}
                  onSort={handleSort}
                  statusBadge
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            {editVehicleTypeData
              ? t("Edit Vehicle Capacity")
              : t("addVehicleCapacity")}
          </Modal.Title>
          <i
            class="fa-solid fa-xmark close-container"
            onClick={handleClose}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <form onSubmit={handleCreateVehicleTypeDetails}>
            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    {t("Vehicle Type")}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>


                  {/* <select
                    id="vehicleType"
                    name="vehicleTypeId"
                    value={formInput.vehicleTypeId}
                    onChange={handleInputChange}
                    className={`form-select ${formInput.vehicleTypeId || !formSubmitted
                      ? ""
                      : "input-error"
                      }`}
                    // disabled={!canWriteValue}
                  >
                    <option value="">Select Vehicle Type</option>
                    {vehicleTypes
                      .filter(vehicleType => vehicleType.isActive)
                      .map((vehicleType) => (
                        <option key={vehicleType.vehicleTypeId} value={vehicleType.vehicleTypeId}>
                          {vehicleType.vehicleTypeName}
                        </option>
                      ))}
                  </select> */}

                  <Select
                    inputId="vehicleType"
                    name="vehicleTypeId"
                    placeholder="Select Vehicle Type"
                    isSearchable
                    isClearable
                    className={
                      formInput.vehicleTypeId || !formSubmitted
                        ? ""
                        : "input-error"
                    }
                    options={
                      vehicleTypes
                        .filter((vehicleType) => vehicleType.isActive)
                        .map((vehicleType) => ({
                          value: String(vehicleType.vehicleTypeId),
                          label: `${vehicleType.vehicleTypeName} - ${vehicleType.collectionTypeName}`,
                        }))
                    }
                    value={
                      vehicleTypes
                        .filter((vehicleType) => vehicleType.isActive)
                        .map((vehicleType) => ({
                          value: String(vehicleType.vehicleTypeId),
                          label: vehicleType.vehicleTypeName ,
                        }))
                        .find(
                          (option) =>
                            String(option.value) ===
                            String(formInput.vehicleTypeId)
                        ) || null
                    }
                    onChange={(selectedOption) => {
                      handleInputChange({
                        target: {
                          name: "vehicleTypeId",
                          value: selectedOption ? selectedOption.value : "",
                        },
                      });
                    }}
                  />

                  {!formInput.vehicleTypeId && formSubmitted && (
                    <div className="required-message">
                      {" "}
                      Vehicle Type is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    {t("Vehicle Capacity Code")}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    name="vehicleCapacityCode"
                    className={`form-control ${formInput.vehicleCapacityCode || !formSubmitted
                      ? ""
                      : "input-error"
                      }`}
                    placeholder="Enter Vehicle Capacity Code"
                    onChange={handleInputChange}
                    value={formInput.vehicleCapacityCode}
                    maxLength={8}
                  // disabled={!canWriteValue}
                  />
                  {!formInput.vehicleCapacityCode && formSubmitted && (
                    <div className="required-message">
                      {" "}
                      Vehicle Capacity Code is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    {t("Vehicle Capacity")}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    name="vehicleCapacityName"
                    maxLength={42}
                    className={`form-control ${formInput.vehicleCapacityName || !formSubmitted
                      ? ""
                      : "input-error"
                      }`}
                    placeholder="Enter Vehicle Capacity"
                    onChange={handleInputChange}
                    value={formInput.vehicleCapacityName}
                  // disabled={!canWriteValue}
                  />
                  {!formInput.vehicleCapacityName && formSubmitted && (
                    <div className="required-message">
                      {" "}
                      Vehicle Capacity is Required
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-4" style={{ marginTop: "5px" }}>
                <label className="form-label">
                  {t("status")}
                  <span style={{ color: "#EC1117" }}> *</span>
                </label>
                <div className="form-group" style={{ display: "flex" }}>
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isActive"
                      id="activeRadio"
                      checked={formInput.isActive} // Set checked attribute to the value of formInput.isActive
                      onChange={() =>
                        handleInputChange({
                          target: { name: "isActive", value: true },
                        })
                      }
                    />

                    <label className="form-check-label" htmlFor="activeRadio">
                      Active
                    </label>
                  </div>
                  <div className="form-check" style={{ marginLeft: "40px" }}>
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isActive"
                      id="inactiveRadio"
                      checked={formInput.isActive === false}
                      onChange={() =>
                        handleInputChange({
                          target: { name: "isActive", value: false }, // Set value to false
                        })
                      }
                    />

                    <label className="form-check-label" htmlFor="inactiveRadio">
                      InActive
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer d-flex justify-content-center">
              {/* {canWriteValue === true ? */}
              <button type="submit" className="deployment-button">
                <i class="fa-solid fa-check done-container"></i>
                {editVehicleTypeData ? t("Update") : t("Save")}
              </button>
              {/* : ''} */}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default withTranslation()(VehicleCapacity);
